import { PhoneTreeService } from '@weave/schema-gen-ts/dist/schemas/phone/tree/v1/phone_tree_service.pb';
import { bindHTTP } from '@frontend/schema';

const SchemaPhoneTreeService = bindHTTP(PhoneTreeService);

export default SchemaPhoneTreeService;

export * as PhoneTreeV1 from './v1';
